/* Accessory product pages (Sava 29 Oct, plan rows P4c and P4c2): site/accessory.html?a=<key>. Built from assets/keepsakes/manifest.json; the 14 former
   Bobblegifts placeholders now use our own pictures (keepsakes/<name>.jpg + -life.jpg, chat B 29 Oct). Pet urn added too (chat B, 29 Oct): all 14 live. Mini-only add-ons have no page:
   CF_ACC_MINI sends them to the mini product page with that extra ticked (phone.html?p=solo&add=<key>). */
/* white mains (pictures B, 31 Oct): mag, bo, ws, wine-opener, photo-clip and dashboard have a white main; the old table main (arrow fixed) is
   picture 2 and the card's hover picture (life), the old life picture is picture 3 (gallery) */
window.CF_ACC={
 "kc": {
  "name": "Bobblehead keychain",
  "img": "keepsakes/kc.jpg",
  "life": "keepsakes/kc-life.jpg",
  "gallery": [],
  "from": 49,
  "desc": "The same face as your mini, on a keychain. Sculpted by hand from your photo.",
  "group": "keepsake",
  "variants": [
   [
    "Person",
    49
   ],
   [
    "Pet",
    49
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": "Who",
  "chips": true,
  "size": "About 3.1 to 3.9 in (8 to 10 cm) tall, steady head",
  "photoLine": {"Pet": "One clear photo of your pet, face and markings in view."},
  "chipAlt": {"Person": "Person keychain", "Pet": "Pet keychain"},
  "petOpt": "Pet"
 },
 "mag": {
  "name": "Fridge magnet",
  "img": "keepsakes/mag.jpg",
  "life": "keepsakes/mag-2.jpg",
  "gallery": ["keepsakes/mag-life.jpg"],
  "from": 39,
  "desc": "Their face on the fridge. A small clay magnet sculpted by hand from your photo.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    39
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "bo": {
  "name": "Bottle opener",
  "img": "keepsakes/bo.jpg",
  "life": "keepsakes/bo-2.jpg",
  "gallery": ["keepsakes/bo-life.jpg"],
  "from": 49,
  "desc": "A bottle opener with their sculpted face on top.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    49
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": "Option"
 },
 "ws": {
  "name": "Wine stopper with their face",
  "img": "keepsakes/ws.jpg",
  "life": "keepsakes/ws-2.jpg",
  "gallery": ["keepsakes/ws-life.jpg"],
  "from": 49,
  "desc": "A wine stopper topped with a small clay version of their face, sculpted by hand from your photo. Sold on its own, no mini needed.",
  "group": "keepsake",
  "variants": [
   [
    "On its own",
    49
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "orn": {
  "name": "Christmas tree ornament",
  "img": "keepsakes/orn.jpg",
  "life": "keepsakes/orn-2.jpg",
  "gallery": ["keepsakes/orn-life.jpg"],
  "from": 49,
  "desc": "Their faces on the tree, every year. Sculpted by hand.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    49
   ]
  ],
  "photo": true,
  "text": "Names or year on the ornament",
  "variantLabel": "Option"
 },
 "orn-me": {
  "name": "Christmas ornament of you",
  "img": "keepsakes/opt/orn-me/santa/orn-me-santa-1-main.jpg",
  "life": "keepsakes/opt/orn-me/santa/orn-me-santa-3-home.jpg",
  "gallery": [],
  "from": 89,
  "desc": "Them, in a Christmas outfit, hanging on the tree.",
  "group": "keepsake",
  "variants": [
   [
    "Santa suit",
    89
   ],
   [
    "Mrs Claus",
    89
   ],
   [
    "Elf",
    89
   ],
   [
    "Ugly sweater",
    89
   ],
   [
    "Reindeer onesie",
    89
   ],
   [
    "Gingerbread suit",
    89
   ],
   [
    "Snow day",
    89
   ],
   [
    "Christmas pajamas",
    89
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": "Outfit",
  "chips": true,
  "size": "About 3.9 in (10 cm) tall, on a red cord",
  "photoLine": "Just their face. The outfit comes from the design.",
  "optNote": {
   "Santa suit": "Red suit, white trim, boots and a sack of gifts.",
   "Mrs Claus": "Red dress, a white apron and a tray of cookies.",
   "Elf": "Green tunic, striped tights and a hat with a bell.",
   "Ugly sweater": "The loudest knit in the house, with a mug in hand.",
   "Reindeer onesie": "A cozy brown onesie with antlers and a red nose.",
   "Gingerbread suit": "Icing trim and gumdrop buttons, face from your photo.",
   "Snow day": "Winter coat, striped scarf, knit hat and a snowball.",
   "Christmas pajamas": "Red plaid pajamas, slippers and a cocoa with marshmallows."
  },
  "chipAlt": {
   "Santa suit": "Christmas ornament of you, Santa suit",
   "Mrs Claus": "Christmas ornament of you, Mrs Claus",
   "Elf": "Christmas ornament of you, Elf",
   "Ugly sweater": "Christmas ornament of you, Ugly sweater",
   "Reindeer onesie": "Christmas ornament of you, Reindeer onesie",
   "Gingerbread suit": "Christmas ornament of you, Gingerbread suit",
   "Snow day": "Christmas ornament of you, Snow day",
   "Christmas pajamas": "Christmas ornament of you, Christmas pajamas"
  },
  "chipName": {
   "Gingerbread suit": "Ginger\u00adbread suit"
  }
 },
 "ps": {
  "name": "Phone stand",
  "img": "keepsakes/ps.jpg",
  "life": "keepsakes/ps-life.jpg",
  "gallery": [],
  "from": 49,
  "desc": "A phone stand with their mini on it.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    49
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": "Option"
 },
 "usb": {
  "name": "USB stick with the mini on top",
  "img": "keepsakes/usb.jpg",
  "life": "keepsakes/usb-life.jpg",
  "gallery": [],
  "from": 59,
  "desc": "A USB stick with their mini on top.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    59
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "case": {
  "name": "Display case",
  "img": "keepsakes/case.jpg",
  "life": "keepsakes/case-life.jpg",
  "gallery": [],
  "from": 35,
  "desc": "Keeps your mini dust-free. Plain, or with an LED light.",
  "group": "addon",
  "variants": [
   [
    "Plain",
    35
   ],
   [
    "With LED light",
    49
   ]
  ],
  "photo": false,
  "text": "",
  "variantLabel": "Option"
 },
 "memorial": {
  "name": "Pet memorial set",
  "img": "keepsakes/memorial.jpg",
  "life": "keepsakes/memorial-life.jpg",
  "gallery": [],
  "from": 189,
  "desc": "A gentle keepsake of your pet, sculpted from their photo.",
  "group": "addon",
  "variants": [
   [
    "One piece",
    189
   ]
  ],
  "photo": true,
  "text": "Your pet's name and dates",
  "variantLabel": ""
 },
 "topper": {
  "name": "Wedding cake topper",
  "img": "keepsakes/topper.jpg",
  "life": "keepsakes/topper-2.jpg",
  "gallery": ["keepsakes/topper-life.jpg"],
  "from": 318,
  "desc": "The two of you on top of the cake, on their own base. Not edible.",
  "group": "addon",
  "variants": [
   [
    "Duo on its own base",
    318
   ]
  ],
  "photo": true,
  "text": "Your names and wedding date",
  "variantLabel": ""
 },
 "frame": {
  "name": "Framed shadow box",
  "img": "keepsakes/frame.jpg",
  "life": "keepsakes/frame-life.jpg",
  "gallery": [],
  "from": 49,
  "desc": "Your mini in a framed shadow box, ready for the wall.",
  "group": "addon",
  "variants": [
   [
    "One piece",
    49
   ]
  ],
  "photo": true,
  "text": "Names or a date on the frame",
  "variantLabel": ""
 },
 "gift": {
  "name": "Gift card",
  "img": "keepsakes/gift.jpg",
  "life": "keepsakes/gift-life.jpg",
  "gallery": [],
  "from": 119,
  "desc": "They pick the idea, send their photo and we sculpt it by hand.",
  "group": "addon",
  "variants": [
   [
    "$119",
    119
   ],
   [
    "$169",
    169
   ],
   [
    "$299",
    299
   ],
   [
    "$429",
    429
   ]
  ],
  "photo": false,
  "text": "",
  "variantLabel": "Amount"
 },
 "house": {
  "name": "House ornament",
  "img": "keepsakes/house.jpg",
  "life": "keepsakes/house-life.jpg",
  "gallery": [],
  "from": 129,
  "desc": "Your home as a hand-sculpted ornament.",
  "group": "addon",
  "variants": [
   [
    "One piece",
    129
   ]
  ],
  "photo": true,
  "text": "Your family name or address line",
  "variantLabel": ""
 },
 "wine-opener": {
  "name": "Wine opener with a face",
  "img": "keepsakes/wine-opener.jpg",
  "life": "keepsakes/wine-opener-2.jpg",
  "gallery": ["keepsakes/wine-opener-life.jpg"],
  "from": 59,
  "desc": "Their face on a T-handle corkscrew.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    59
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "dashboard": {
  "name": "Car dashboard figure",
  "img": "keepsakes/car-dashboard.jpg",
  "life": "keepsakes/car-dashboard-2.jpg",
  "gallery": ["keepsakes/car-dashboard-life.jpg"],
  "from": 59,
  "desc": "Sculpted by hand. Keep out of strong sun.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    59
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "pet-frame": {
  "name": "Pet head wall frame",
  "img": "keepsakes/pet-head-frame.jpg",
  "life": "keepsakes/pet-head-frame-2.jpg",
  "gallery": ["keepsakes/pet-head-frame-life.jpg"],
  "from": 69,
  "desc": "Sculpted by hand from your photo.",
  "group": "pets",
  "variants": [
   [
    "One piece",
    69
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "pet-cake-topper": {
  "name": "Funny pet cake topper",
  "img": "keepsakes/pet-cake-topper.jpg",
  "life": "keepsakes/pet-cake-topper-2.jpg",
  "gallery": ["keepsakes/pet-cake-topper-life.jpg"],
  "from": 59,
  "desc": "Sculpted by hand from your photo. Not edible.",
  "group": "pets",
  "variants": [
   [
    "One piece",
    59
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "music-box": {
  "name": "Music-box base",
  "img": "keepsakes/music-box.jpg",
  "life": "keepsakes/music-box-life.jpg",
  "gallery": [],
  "from": 30,
  "desc": "Sculpted by hand from your photo.",
  "group": "addon",
  "variants": [
   [
    "One piece",
    30
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "pet-necklace": {
  "name": "Pet portrait necklace",
  "img": "keepsakes/pet-necklace.jpg",
  "life": "keepsakes/pet-necklace-2.jpg",
  "gallery": ["keepsakes/pet-necklace-life.jpg"],
  "from": 45,
  "desc": "Sculpted by hand from your photo.",
  "group": "pets",
  "variants": [
   [
    "One piece",
    45
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "photo-clip": {
  "name": "Photo clip mini",
  "img": "keepsakes/photo-clip.jpg",
  "life": "keepsakes/photo-clip-2.jpg",
  "gallery": ["keepsakes/photo-clip-life.jpg"],
  "from": 59,
  "desc": "Sculpted by hand from your photo.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    59
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "toy-box": {
  "name": "Action-figure box packaging",
  "img": "keepsakes/action-figure-box.jpg",
  "life": "keepsakes/action-figure-box-2.jpg",
  "gallery": ["keepsakes/action-figure-box-life.jpg"],
  "from": 80,
  "desc": "Sculpted by hand from your photo.",
  "group": "addon",
  "variants": [
   [
    "One piece",
    80
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "kids-badge": {
  "name": "Proud parent face badge",
  "img": "keepsakes/kids-badge.jpg",
  "life": "keepsakes/kids-badge-2.jpg",
  "gallery": ["keepsakes/kids-badge-life.jpg"],
  "from": 49,
  "desc": "A keepsake pin for a proud parent's coat.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    49
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "hair-tie": {
  "name": "Hair tie with face",
  "img": "keepsakes/hair-tie.jpg",
  "life": "keepsakes/hair-tie-life.jpg",
  "gallery": [],
  "from": 49,
  "desc": "Sculpted by hand from your photo.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    49
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "fork-spoon": {
  "name": "Fork and spoon keepsake with family faces",
  "img": "keepsakes/fork-and-spoon.jpg",
  "life": "keepsakes/fork-and-spoon-2.jpg",
  "gallery": ["keepsakes/fork-and-spoon-life.jpg"],
  "from": 99,
  "desc": "A display keepsake, not for meals.",
  "group": "keepsake",
  "variants": [
   [
    "One piece",
    99
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "pet-bed": {
  "name": "Pet bed base",
  "img": "keepsakes/pet-bed-base.jpg",
  "life": "keepsakes/pet-bed-base-2.jpg",
  "gallery": ["keepsakes/pet-bed-base-life.jpg"],
  "from": 80,
  "desc": "Sculpted by hand from your photo.",
  "group": "pets",
  "variants": [
   [
    "One piece",
    80
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "big-vehicle": {
  "name": "Big vehicle: tractor or train",
  "img": "keepsakes/big-vehicle.jpg",
  "life": "keepsakes/big-vehicle-2.jpg",
  "gallery": ["keepsakes/big-vehicle-life.jpg"],
  "from": 199,
  "desc": "Sculpted by hand from your photo.",
  "group": "addon",
  "variants": [
   [
    "One piece",
    199
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 },
 "pet-urn": {
  "name": "Pet urn with figure on the lid",
  "img": "keepsakes/pet-urn.jpg",
  "life": "keepsakes/pet-urn-2.jpg",
  "gallery": ["keepsakes/pet-urn-life.jpg"],
  "from": 109,
  "desc": "Sculpted by hand from your photo.",
  "group": "pets",
  "variants": [
   [
    "One piece",
    109
   ]
  ],
  "photo": true,
  "text": "",
  "variantLabel": ""
 }
};
/* Accessories taken off the site: the list is CF_ACC_OFF in assets/menu.js (30 Oct). */
(window.CF_ACC_OFF||[]).forEach(k=>{delete window.CF_ACC[k];}); /* when menu.js ran first; otherwise menu.js removes them */
window.CF_ACC_MINI={"pet": {"p": "solo", "add": "pet"}, "plate": {"p": "solo", "add": "plate"}, "second": {"p": "solo", "add": "second"}, "box": {"p": "solo", "add": "box"}, "car": {"p": "solo", "add": "car"}, "grow": {"p": "solo", "add": "grow"}};
window.cfAccHref=function(k,root){root=root||"";if(k==="grow")return root+"site/grow.html";if(window.CF_ACC_MINI[k])return root+"phone.html?p="+window.CF_ACC_MINI[k].p+"&add="+window.CF_ACC_MINI[k].add;return root+"site/accessory.html?a="+k;};
